var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { stripSiteMetadata } from './siteMetadata';
import { DEFAULT_FILTER_CONFIGURATION } from '../parsing/UiTypesSpec';
import { parseModules } from '../parsing/parse';
import { applyDiff, convertOptionsToStrings, EMPTY_DIFF } from './ListDiffUtils';
export var renderFilter = function (filter, activeConfig) {
    var _a, _b, _c;
    var filterModules = filter.modules.filter(function (module) {
        var _a;
        var enabledConfig = (_a = activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.enabledModules) === null || _a === void 0 ? void 0 : _a[module.id];
        return enabledConfig !== null && enabledConfig !== void 0 ? enabledConfig : module.enabled;
    });
    var modules = __spreadArray(__spreadArray(__spreadArray([], (((_a = parseModules((activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.prefixRs2f) || '')) === null || _a === void 0 ? void 0 : _a.modules) || []), true), filterModules, true), (((_b = parseModules((activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.suffixRs2f) || '')) === null || _b === void 0 ? void 0 : _b.modules) || []), true);
    var theme = (_c = filter.themes) === null || _c === void 0 ? void 0 : _c.find(function (theme) { return theme.id === (activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.selectedThemeId); });
    var filterText = modules
        .map(function (m) { return applyModule(m, activeConfig === null || activeConfig === void 0 ? void 0 : activeConfig.inputConfigs, theme); })
        .join('\n');
    filterText = filterText.replace(/meta\s*{([^}]*)}/, "meta { name = \"".concat(filter.name, "\";").concat(filter.description
        ? " description = \"".concat(filter.description, "\";")
        : '', " }"));
    // JSON is valid YAML. Escape comment terminators even inside custom rs2f.
    var metadata = JSON.stringify({
        version: 1,
        source: filter.source,
        commit: filter.commit,
        revisionUrl: filter.revisionUrl,
        sourceHash: filter.rs2fHash === '00000000' ? undefined : filter.rs2fHash,
        name: filter.name,
        description: filter.description,
        config: activeConfig !== null && activeConfig !== void 0 ? activeConfig : DEFAULT_FILTER_CONFIGURATION,
    }).replace(/\*/g, '\\u002a');
    return "".concat(stripSiteMetadata(filterText), "\n/*@ define:sitemeta\n").concat(metadata, "\n*/\n");
};
export var applyModule = function (module, config, theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var updated = module.rs2f;
    for (var _i = 0, _q = module.inputs; _i < _q.length; _i++) {
        var input = _q[_i];
        switch (input.type) {
            case 'boolean': {
                var bool = (_c = (_a = config === null || config === void 0 ? void 0 : config[input.macroName]) !== null && _a !== void 0 ? _a : (_b = theme === null || theme === void 0 ? void 0 : theme.config) === null || _b === void 0 ? void 0 : _b.inputConfigs[input.macroName]) !== null && _c !== void 0 ? _c : input.default;
                if (bool !== undefined) {
                    updated = updateMacro(updated, input.macroName, bool.toString());
                }
                break;
            }
            case 'number': {
                var value = (_f = (_d = config === null || config === void 0 ? void 0 : config[input.macroName]) !== null && _d !== void 0 ? _d : (_e = theme === null || theme === void 0 ? void 0 : theme.config) === null || _e === void 0 ? void 0 : _e.inputConfigs[input.macroName]) !== null && _f !== void 0 ? _f : input.default;
                if (value !== undefined) {
                    updated = updateMacro(updated, input.macroName, value.toString());
                }
                break;
            }
            case 'stringlist':
            case 'enumlist': {
                var configuredDiff = config === null || config === void 0 ? void 0 : config[input.macroName];
                var themeDiff = (_h = (_g = theme === null || theme === void 0 ? void 0 : theme.config) === null || _g === void 0 ? void 0 : _g.inputConfigs) === null || _h === void 0 ? void 0 : _h[input.macroName];
                var list = convertOptionsToStrings(applyDiff(input.default, [
                    themeDiff,
                    configuredDiff !== null && configuredDiff !== void 0 ? configuredDiff : EMPTY_DIFF,
                ]));
                updated = updateMacro(updated, input.macroName, renderStringList(list));
                break;
            }
            case 'style': {
                var style = config === null || config === void 0 ? void 0 : config[input.macroName];
                var themeStyle = (_k = (_j = theme === null || theme === void 0 ? void 0 : theme.config) === null || _j === void 0 ? void 0 : _j.inputConfigs) === null || _k === void 0 ? void 0 : _k[input.macroName];
                var defaultStyle = input.default;
                var mergedStyle = __assign(__assign(__assign({}, (defaultStyle !== null && defaultStyle !== void 0 ? defaultStyle : {})), (themeStyle !== null && themeStyle !== void 0 ? themeStyle : {})), (style !== null && style !== void 0 ? style : {}));
                if (Object.keys(mergedStyle).length > 0) {
                    updated = updateMacro(updated, input.macroName, renderStyle(mergedStyle));
                }
                break;
            }
            case 'text': {
                var text = ((_p = (_l = config === null || config === void 0 ? void 0 : config[input.macroName]) !== null && _l !== void 0 ? _l : (_o = (_m = theme === null || theme === void 0 ? void 0 : theme.config) === null || _m === void 0 ? void 0 : _m.inputConfigs) === null || _o === void 0 ? void 0 : _o[input.macroName]) !== null && _p !== void 0 ? _p : input.default);
                if (text !== undefined) {
                    updated = updateMacro(updated, input.macroName, "\"".concat(text, "\""));
                }
                break;
            }
        }
    }
    return updated;
};
var renderStringList = function (list) {
    return "[".concat(list.map(quote).join(','), "]");
};
var quote = function (v) { return "\"".concat(v, "\""); };
var renderStyle = function (style) {
    if (style.hidden) {
        return 'hidden = true;'; // save space, nothing else matters
    }
    return [
        renderStyleBool('hidden', style.hidden),
        renderStyleColor('textColor', style.textColor),
        renderStyleColor('backgroundColor', style.backgroundColor),
        renderStyleColor('borderColor', style.borderColor),
        renderStyleColor('textAccentColor', style.textAccentColor),
        renderStyleColor('lootbeamColor', style.lootbeamColor),
        renderStyleColor('menuTextColor', style.menuTextColor),
        renderStyleColor('tileStrokeColor', style.tileStrokeColor),
        renderStyleColor('tileHighlightColor', style.tileHighlightColor),
        renderStyleInt('textAccent', style.textAccent),
        renderStyleInt('fontType', style.fontType),
        renderStyleBool('showLootbeam', style.showLootbeam),
        renderStyleBool('showValue', style.showValue),
        renderStyleBool('showDespawn', style.showDespawn),
        renderStyleBool('notify', style.notify),
        renderStyleBool('highlightTile', style.highlightTile),
        renderStyleString('sound', style.sound),
        renderStyleInt('menuSort', style.menuSort),
        renderStyleIcon(style.icon),
    ].join('');
};
var renderStyleColor = function (name, color) {
    return color !== undefined ? "".concat(name, " = \"").concat(color, "\";") : '';
};
var renderStyleInt = function (name, int) {
    return int !== undefined ? "".concat(name, " = ").concat(int, ";") : '';
};
var renderStyleBool = function (name, value) {
    return value !== undefined ? "".concat(name, " = ").concat(value, ";") : '';
};
var renderStyleIcon = function (icon) {
    var _a, _b, _c;
    switch (icon === null || icon === void 0 ? void 0 : icon.type) {
        case 'sprite':
            return "icon = Sprite(".concat((_a = icon.spriteId) !== null && _a !== void 0 ? _a : 0, ", ").concat((_b = icon.spriteIndex) !== null && _b !== void 0 ? _b : 0, ");");
        case 'file':
            return "icon = File(\"".concat(icon.path, "\");");
        case 'itemId':
            return "icon = Item(".concat((_c = icon.itemId) !== null && _c !== void 0 ? _c : 0, ");");
        case 'current':
            return 'icon = CurrentItem();';
        case 'none':
        default:
            return '';
    }
};
var renderStyleString = function (name, value) {
    if (typeof value === 'number') {
        return "".concat(name, " = ").concat(value, ";");
    }
    return value !== undefined ? "".concat(name, " = \"").concat(value, "\";") : '';
};
var isTargetMacro = function (line, target) {
    return line.startsWith("#define ".concat(target, " ")) || line === "#define ".concat(target);
};
// This WILL handle multiline macros but it's not perfect, if you have
// whitespace after the trailing slash that will break it even though it's
// valid rs2f. Long-term we'll just have the full tokenizer on the site and
// this will be handled better.
var updateMacro = function (filter, macro, replace) {
    var replaced = [];
    var inMultiline = false;
    for (var _i = 0, _a = filter.split('\n'); _i < _a.length; _i++) {
        var line = _a[_i];
        if (isTargetMacro(line, macro)) {
            if (line.endsWith('\\')) {
                inMultiline = true;
            }
            else {
                // it's a one-line define, replace it and we're done
                replaced.push("#define ".concat(macro, " ").concat(replace));
            }
        }
        else if (inMultiline) {
            if (!line.endsWith('\\')) {
                // we finished the multiline define, push our replace and carry on
                replaced.push("#define ".concat(macro, " ").concat(replace));
                inMultiline = false;
            }
        }
        else {
            replaced.push(line);
        }
    }
    return replaced.join('\n');
};
